import { useTranslation } from 'react-i18next'

function Footer() {
  const { t } = useTranslation()

  return (
    <footer className="w-full border-t border-[color:var(--header-line)]/70 bg-transparent">
      <div className="mx-auto flex max-w-7xl justify-center px-8 py-10">
        <div className="flex flex-wrap justify-center gap-6 md:gap-8">
          <a className="font-mono text-[12px] uppercase tracking-[0.22em] text-[color:var(--header-muted)] hover:text-[color:var(--header-ink)] transition-colors" href="#">
            {t('footer.links.terms')}
          </a>
          <a className="font-mono text-[12px] uppercase tracking-[0.22em] text-[color:var(--header-muted)] hover:text-[color:var(--header-ink)] transition-colors" href="#">
            {t('footer.links.privacy')}
          </a>
          <a className="font-mono text-[12px] uppercase tracking-[0.22em] text-[color:var(--header-muted)] hover:text-[color:var(--header-ink)] transition-colors" href="#">
            {t('footer.links.contact')}
          </a>
          <a className="font-mono text-[12px] uppercase tracking-[0.22em] text-[color:var(--header-muted)] hover:text-[color:var(--header-ink)] transition-colors" href="#">
            {t('footer.links.instagram')}
          </a>
        </div>
      </div>
    </footer>
  )
}

export default Footer
